import { useState, useEffect } from 'react';

const useLargeBreakpoint = (strict = false) => {
  const [isAtLeastLarge, setIsAtLeastLarge] = useState(false);

  const onChanged = (event) => {
    setIsAtLeastLarge(event.matches);
  };

  useEffect(() => {
    const strictQuery =
      'only screen and (min-width: 960px) and (max-width: 1199px)';
    const defaultQuery = 'only screen and (min-width: 960px)';

    const mediaQueryList = window.matchMedia(
      strict ? strictQuery : defaultQuery
    );

    setIsAtLeastLarge(mediaQueryList.matches);

    try {
      mediaQueryList.addEventListener('change', onChanged);
    } catch {
      mediaQueryList.addListener(onChanged);
    }

    return () => {
      try {
        mediaQueryList.removeEventListener('change', onChanged);
      } catch {
        mediaQueryList.removeListener(onChanged);
      }
    };
  }, []);

  return isAtLeastLarge;
};

export default useLargeBreakpoint;
